import React, {FC} from "react";
import {useTolgee} from "@tolgee/react";
import {useLanguageSelection, usePublishedLanguages} from "hooks";
import {TOLGEE_LANGUAGE_STORAGE_KEY} from "tools/localization/constants";
import LanguagePicker from "./index";

type PublicLanguagePickerProps = {
  hideWhenNoStoredLanguage?: boolean;
};

const PublicLanguagePicker: FC<PublicLanguagePickerProps> = ({
  hideWhenNoStoredLanguage,
}) => {
  const tolgee = useTolgee(["language"]);
  const {languages} = usePublishedLanguages();
  const onSelect = useLanguageSelection();

  if (
    hideWhenNoStoredLanguage &&
    !localStorage.getItem(TOLGEE_LANGUAGE_STORAGE_KEY)
  ) {
    return null;
  }

  return (
    <LanguagePicker
      languages={languages}
      currentCode={tolgee.getLanguage()}
      onSelect={onSelect}
      id="public-language-picker"
    />
  );
};

export default PublicLanguagePicker;
